/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMobiledata = createReactComponent("mobiledata", "IconMobiledata", [
  ["path", { d: "M16 12v-8", key: "svg-0" }],
  ["path", { d: "M8 20v-8", key: "svg-1" }],
  ["path", { d: "M13 7l3 -3l3 3", key: "svg-2" }],
  ["path", { d: "M5 17l3 3l3 -3", key: "svg-3" }]
]);

export { IconMobiledata as default };
//# sourceMappingURL=IconMobiledata.js.map
